module.exports=/[\0-\x1F\x7F-\x9F]/


//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/uc.micro/categories/Cc/regex.js
// module id = 387
// module chunks = 168707334958949